
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Procurement } from '@/types/procurement';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BarChart2 } from 'lucide-react';

type PendingCardProps = {
  procurement: Procurement;
  onStartAnalysis: (procurementId: string) => Promise<void>;
};

const PendingCard = ({ procurement, onStartAnalysis }: PendingCardProps) => {
  const navigate = useNavigate();
  
  return (
    <Card key={procurement.id}>
      <CardHeader className="pb-3">
        <div className="flex justify-between items-start">
          <div>
            <CardTitle className="text-lg">{procurement.title}</CardTitle>
            <CardDescription className="mt-1">
              {procurement.authority} • Tillagd {new Date(procurement.created_at).toLocaleDateString('sv-SE')}
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-blue-600">
            <BarChart2 size={18} />
            <span>Väntar på att starta analys</span>
          </div>
          
          <div className="flex gap-2">
            <Button 
              variant="outline" 
              size="sm"
              onClick={() => navigate(`/procurements/${procurement.id}/edit`)}
            >
              Redigera upphandling
            </Button>
            <Button 
              size="sm"
              onClick={() => onStartAnalysis(procurement.id)}
            >
              Starta analys
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PendingCard;
